import { isBrowser } from '../generic'
import * as Sentry from '@sentry/gatsby'

const CACHE_DURATION = 60000
const STORAGE_KEY = 'openBetsCount'
const STORAGE_TIMESTAMP_KEY = 'openBetsCountTimestamp'

const logStorageError = (error, action, extra = {}) => {
  Sentry.captureException(error, {
    tags: {
      component: 'openBetsStorage',
      action,
    },
    extra: {
      storageKey: STORAGE_KEY,
      storageTimestampKey: STORAGE_TIMESTAMP_KEY,
      ...extra,
    },
  })
}

export const loadFromStorage = () => {
  if (!isBrowser()) return null

  try {
    const storedCount = localStorage.getItem(STORAGE_KEY)
    const storedTimestamp = localStorage.getItem(STORAGE_TIMESTAMP_KEY)

    if (storedCount && storedTimestamp) {
      const timestamp = parseInt(storedTimestamp, 10)
      const now = Date.now()

      if (now - timestamp < CACHE_DURATION) {
        return parseInt(storedCount, 10)
      }
    }
  } catch (err) {
    logStorageError(err, 'loadFromStorage')
  }

  return null
}

export const saveToStorage = (count) => {
  if (!isBrowser()) return

  try {
    localStorage.setItem(STORAGE_KEY, count.toString())
    localStorage.setItem(STORAGE_TIMESTAMP_KEY, Date.now().toString())
  } catch (err) {
    logStorageError(err, 'saveToStorage', { count })
  }
}

export const shouldUseCache = (lastFetchTime, cachedCount, force = false) => {
  const now = Date.now()
  return !force && now - lastFetchTime < CACHE_DURATION && cachedCount > 0
}
